import { usePath } from '@elsa/ui';
import { AppShell } from './app/AppShell.tsx';
import { AuthPage, NewPasswordPage } from './pages/Auth.tsx';
import { InvitePage } from './pages/Invite.tsx';
import { LandingPage } from './pages/Landing.tsx';
import { CookiesPage, PrivacyPage, TermsPage } from './pages/Legal.tsx';
import { NotFound, PublicLayout } from './pages/PublicLayout.tsx';

// Rutele publice (prezentarea, paginile legale, autentificarea) si aplicatia de sub /app.
export function App() {
  const path = usePath();
  if (path === '/app' || path.startsWith('/app/')) return <AppShell path={path} />;
  const page = (() => {
    switch (path) {
      case '/':
        return <LandingPage />;
      case '/termeni':
        return <TermsPage />;
      case '/confidentialitate':
        return <PrivacyPage />;
      case '/cookie-uri':
        return <CookiesPage />;
      case '/autentificare':
        return <AuthPage />;
      case '/parola-noua':
        return <NewPasswordPage />;
      case '/invitatie':
        return <InvitePage />;
      default:
        return <NotFound />;
    }
  })();
  return <PublicLayout>{page}</PublicLayout>;
}
